import { DotsCheckbox } from "dots-ui/dotsCheckbox";
import { IColumnConfig, ITableColumnProps } from "dots-ui/dotsTable";
import moment from "moment";
import { AvisConstants } from "../../../../data/avisConstants";
import { LicenseInvoicePlanListInfo } from "../../../../generated/data-contracts";
import {
  IColumnConfigConditional,
  ILinkValue,
  LicenseInvoicePlanInfo,
  ResCallback,
} from "../../../../models";
import { LicenseesUrls, LicenseesUtils, TableUtils } from "../../../../utils";

export const columnConfigLicenseReports = (
  licenseId: number | undefined,
  res: ResCallback,
): IColumnConfig[] => {
  const licenseObjectColumnTemplate = (
    rowData: LicenseInvoicePlanInfo,
    column: ITableColumnProps,
  ): JSX.Element => {
    if (!column.field || !rowData.licenseHeaderId) return <></>;

    if (
      !rowData.objects ||
      !Array.isArray(rowData.objects) ||
      rowData.objects.length === 0
    )
      return <></>;

    const objectsCollection = rowData.objects.map((x) => {
      const objectValue = LicenseesUtils.getLicenseObjectValue(x);

      return (
        <div
          key={`lid_${rowData.licenseHeaderId}_object_${x.name}_${x.address}`}
          className="license-object-record table-cell-value-overflow"
          title={objectValue}
        >
          {objectValue}
        </div>
      );
    });

    return <div>{objectsCollection}</div>;
  };

  const columnCollection: IColumnConfig[] = [
    ...(!licenseId
      ? [
          TableUtils.columnConfigLink<LicenseInvoicePlanInfo>(
            "licenseNumber",
            res("licensees_License_label_License"),
            (rowData) => {
              return {
                title: rowData.licenseNumber,
                url: LicenseesUtils.getUrlWithParams(
                  LicenseesUrls.licenseeLicenseView,
                  { licenseId: rowData.licenseHeaderId },
                ),
              } as ILinkValue;
            },
            AvisConstants.table_column_license_number_width,
          ),
          TableUtils.columnConfig<LicenseInvoicePlanInfo>(
            "objects",
            res("licensees_License_label_ObjectName"),
            "Object",
            licenseObjectColumnTemplate,
          ),
        ]
      : []),

    TableUtils.columnConfigPeriod<LicenseInvoicePlanInfo>(
      "periodFrom",
      "periodTo",
      res("label_ReportPeriod"),
      (rowData) => {
        if (!rowData.licenseSettingsInfo?.licenseReportFormType) return;

        return LicenseesUtils.getUrlWithParams(
          LicenseesUrls.licenseeLicenseViewReport,
          {
            licenseId: rowData.licenseHeaderId,
            licenseReportFormType:
              rowData.licenseSettingsInfo.licenseReportFormType,
            licenseInvoicePlanId: rowData.licenseInvoicePlanId,
          },
        );
      },
      AvisConstants.table_column_period_width,
    ),
    TableUtils.columnConfigDateTime<LicenseInvoicePlanInfo>(
      "reportDue",
      res("licensees_LicenseReports_label_ReportDue"),
      undefined,
      120,
    ),

    TableUtils.columnConfigBoolean<LicenseInvoicePlanInfo>(
      "eventNotOccuredPortal",
      res("licensees_License_label_EventNotOccured"),
      res,
      50,
      { trueValue: <DotsCheckbox checked disabled />, falseValue: "" },
    ),

    TableUtils.columnConfigNested<LicenseInvoicePlanInfo>(
      "portalReportStatusType",
      "shortName",
      res("licensees_LicenseReports_label_Status"),
      150,
    ),
  ];

  return columnCollection;
};

export const conditionalFormattingReportDue: IColumnConfigConditional<LicenseInvoicePlanListInfo> =
  {
    field: "reportDue",
    trueClass: "avis-highlight-red",
    falseClass: "",
    condition: (val) => {
      return (
        moment(val).startOf("day") <= moment().add(1, "day").startOf("day") //tomorrow
      );
    },
  };
